import React, { Component } from 'react';
import { Modal, Icon, Segment, Card, Message, Divider, Button, Image } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';
import { DyzioPrimaryButton } from 'dyzio-shared-components/lib/components/dyzio-buttons';
import { compose } from 'recompose';
import _ from 'lodash';
import PropTypes from 'prop-types';
import hasRESTClient from '../../hocs/has-rest-client';

const textCenter = {
  textAlign: 'center',
};

const noShadowStyle = {
  boxShadow: 'none',
};

const loadingStyle = {
  minHeight: 212,
  textAlign: 'center',
  paddingTop: 61,
  color: 'gray',
};

const buttonStyle = {
  minWidth: 220,
  display: 'block',
  margin: '0 auto',
};

const ITEMS_PER_ROW = 3;

class TokenMediaModal extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      media: [],
      isError: false,
    };
    // this.axiosCancelSource = axios.CancelToken.source();
  }

  async componentDidMount() {
    const { oauthResponseId, accountId, oauthTokenAPIClient } = this.props;

    const response = await oauthTokenAPIClient
      .get(`oauthresponse/media/${oauthResponseId}/${accountId}`)
      .catch(err => {
        console.log(err);
      });

    if (response) {
      const { data } = response;
      console.log(data);
      this.setState({
        isLoading: false,
        media: data,
        isError: false,
      });
    }
  }

  componentWillUnmount() {
    // todo TEST THE DEMOGRAPHICS
  }

  render() {
    const {
      onClose,
      onConfirm,
      accountId,
      oauthResponseId,
      tokenConfirmationInProgress,
    } = this.props;
    const { isLoading, isError, media } = this.state;
    const modalStyle = { minHeight: 450 };
    const noMedia = _.isEmpty(media);
    return (
      <Modal
        open
        onClose={onClose}
        closeOnDimmerClick
        size="large"
        closeOnDocumentClick
      >
        <DyzioModalHeader headerText="Your last 3 posts..." />
        <Modal.Content style={modalStyle}>
          {
            isLoading && (
              <Segment style={loadingStyle}>
                <Icon name="refresh" loading size="huge" />
                <Divider hidden />
                <h3>Loading</h3>
              </Segment>
            )
          }
          {
            !isLoading && noMedia && (
              <div>
                <Message warning style={textCenter}>
                  <Icon name="frown" size="huge" />
                  <Divider hidden />
                    Something does not look right…
                  <br />
                    we could not load any media for this account.
                </Message>
                <Divider hidden />
                <Button style={buttonStyle} onClick={onClose}>
                  <Icon name="close" />
                  Close
                </Button>
              </div>
            )
          }
          {
            !isLoading && !isError && !_.isEmpty(media) && (
              <div style={{ textAlign: 'center' }}>
                <Card.Group itemsPerRow={ITEMS_PER_ROW}>
                  { _.map(_.take(media, ITEMS_PER_ROW), item => (
                    <Card style={noShadowStyle}>
                      <Image
                        src={item.media_url}
                      />
                    </Card>
                  ))}
                </Card.Group>
                <Divider />
                <DyzioPrimaryButton
                  disabled={tokenConfirmationInProgress}
                  onClick={() => onConfirm({
                    accountId,
                    oauthResponseId,
                  })}
                  size="large"
                  label="Confirm Account"
                  hasIcon
                  icon={<Icon name="check" />}
                  floated={false}
                />
              </div>
            )
          }
          {
            !isLoading && isError && <div>bad token</div>
          }
        </Modal.Content>
      </Modal>
    );
  }
}

TokenMediaModal.propTypes = {
  accountId: PropTypes.string.isRequired,
  oauthResponseId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  tokenConfirmationInProgress: PropTypes.bool.isRequired,
};

export default compose(
  hasRESTClient,
)(TokenMediaModal);



/** WEBPACK FOOTER **
 ** ./src/components/token-media-modal/index.js
 **/